import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import Spacer from "components/Spacer";
import { isLoggedIn } from "utils";

import './index.css'


export default (WrappedComponent) => {
  class withLoader extends React.Component {
    showLoading = () => {
      this.loader.style.visibility = 'visible';
    };

    hideLoading = () => {
      this.loader.style.visibility = 'hidden';
    };

    render() {
      return (
        <div
          style={{
            position: 'relative',
            width: '100%'
          }}
        >
          <WrappedComponent {...this.props} showLoading={this.showLoading} hideLoading={this.hideLoading} />
          <div
            ref={ref => this.loader = ref}
            style={{
              visibility: 'hidden',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div className="sk-folding-cube">
              <div className="sk-cube1 sk-cube"></div>
              <div className="sk-cube2 sk-cube"></div>
              <div className="sk-cube4 sk-cube"></div>
              <div className="sk-cube3 sk-cube"></div>
            </div>
          </div>
        </div>
      );
    }
  }

  hoistNonReactStatic(withLoader, WrappedComponent);

  return withLoader;
}